import {Component} from '@angular/core';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ConfirmationDialogComponent} from "../shared/confirmation-dialog/confirmation-dialog.component";
import {ConfirmationDialogData} from "../_types/shared";
import {AuthService} from "../_services/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ContentService} from "../_services/content.service";
import {Community} from "../_types/communities";

@Component({
    selector: 'app-communication-preferences',
    templateUrl: './communication-preferences.component.html',
    styleUrl: './communication-preferences.component.scss'
})
export class CommunicationPreferencesComponent {
    currentCommunity: Community | null = null;

    constructor(private readonly dialog: MatDialog,
                private authService: AuthService,
                private contentService: ContentService,
                private readonly snackBar: MatSnackBar) {
        this.contentService.getCurrentDashboardCommunity()
            .pipe(takeUntilDestroyed())
            .subscribe(community => {
                this.currentCommunity = community
            });
    }

    isLoggedIn(): boolean {
        return localStorage.getItem('access_token') != null;
    }

    leave(): void {
        const dialogRef: MatDialogRef<ConfirmationDialogComponent> = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData>(ConfirmationDialogComponent, {
            panelClass: 'mediumWindow',
            data: {
                showSubmitBtn: true,
                showCancelBtn: true,
                message: 'Are you sure you want to leave the community? Your account will be deactivated and all content anonymised.',
                title: 'Report comment',
                showHeader: true,
                confirmCheck: 'I\'m leaving, get me out of here'
            }
        });
        dialogRef.afterClosed().subscribe(r => {
            if (this.currentCommunity?.id) {
                this.authService.leaveCommunity(this.currentCommunity.id).subscribe(r => {
                    this.snackBar.open('Left community successfully', 'Dismiss', {
                        duration: 5000,
                        panelClass: ['success']
                    });

                    this.authService.logout();

                }, error => {
                    this.snackBar.open(error, 'Dismiss', {
                        duration: 5000,
                        panelClass: ['error']
                    });
                })
            } else {
                this.snackBar.open('Couldn\'t determine current community please try again', 'Dismiss', {
                    duration: 5000,
                    panelClass: ['error']
                });
            }
        })
    }
}
